<ng-container>
    <app-basic-card>
        <app-basic-form [form]="searchForm" [keys]="searchFormKeys"></app-basic-form>
        <button mat-raised-button color="primary" (click)="onSearchClick()" [disabled]="!searchForm.valid">{{'ricerca' | uppercase}}</button>
        <button mat-button color="warn" class="mx-3" (click)="reset()">{{'reset' | uppercase}}</button>
    </app-basic-card>
    <ng-container *ngIf="searchCompleted">
        <div class="mt-3 pt-3" *ngIf="searchedSubject; else emptySearchResult">
            <h6 class="card-header-label" style="padding-left: 1em;">Soggetto ricercato</h6>
            <app-policy-card [item]="searchedSubject" [title]="subjectName" [keys]="subjectKeys" [tooltip]="'Nuovo contraente'"></app-policy-card>
        </div>
        <ng-container>
            <div class="mt-3 pt-3">
                <h6 class="card-header-label" style="padding-left: 1em;">Tutore / Rappresentante Legale</h6>
                <app-basic-card>
                    <ng-container *ngIf="isSearchedSubjectPF">
                        <app-basic-form [form]="legalGuardianForm" [keys]="legalGuardianFormKeys"></app-basic-form>
                    </ng-container>
                    <div class="mt-3 mb-2" *ngIf="canAddLegalGuardian">
                        <ng-container *ngIf="searchedLegalGuardian">
                            <app-policy-card [item]="searchedLegalGuardian" [title]="legalGuardianName" [keys]="legalGuardianKeys" [tooltip]="'Tutore legale'"></app-policy-card>
                        </ng-container>
                        <div class="mt-3">
                            <button mat-raised-button color="primary" (click)="openLegalGuardianSearchModal()" [disabled]="isReadOnly">
                                Aggiungi Tutore / Rappresentante Legale
                            </button>
                        </div>
                    </div>
                </app-basic-card>
            </div>
        </ng-container>
        <ng-template #emptySearchResult>
            <div class="mt-3 pt-3">
                <p class="text-center">Nessun soggetto trovato. È possibile inserire i dati completi nel prossimo step.</p>
            </div>
        </ng-template>
    </ng-container>
</ng-container>